// https://gist.github.com/liabru/11263260
export function triggerDownload(
  content: string,
  filename: string,
  type = "text/plain"
) {
  const blob = new Blob([content], { type: type }),
    anchor = document.createElement("a");
  anchor.download = filename;
  anchor.href = (window.webkitURL || window.URL).createObjectURL(blob);
  anchor.dataset.downloadurl = [type, anchor.download, anchor.href].join(":");
  anchor.click();
}
